import { BusinessMemberDetails } from '@/types/businesses';
import { SVTable } from '../core';
import { SVTableRow } from '@/types/common';

type BusinessMembersTableProps = {
  members: BusinessMemberDetails[];
};

export default function BusinessMembersTable({
  members,
}: BusinessMembersTableProps) {
  const rows: SVTableRow[] = members.map(member => {
    const { uuid, consumer, isControlPerson, title, ownershipPercentage } =
      member;

    return {
      key: `member${uuid}`,
      cells: [
        {
          content: consumer.fullName,
          type: 'text',
          key: `name${uuid}`,
        },
        {
          content: title,
          type: 'text',
          key: `title${uuid}`,
        },
        {
          content: isControlPerson ? 'Yes' : 'No',
          type: 'text',
          key: `control${uuid}`,
        },
        {
          content: `${ownershipPercentage}%`,
          type: 'text',
          key: `ownershipPercent${uuid}`,
        },
        {
          content: consumer.lastLogin,
          type: 'date',
          key: `lastLogin${uuid}`,
        },
      ],
    };
  });

  return (
    <SVTable
      ariaLabel="Members"
      headers={[
        {
          key: 'name',
          content: 'Name',
        },
        {
          key: 'title',
          content: 'Title',
        },
        {
          key: 'control',
          content: 'Control Person',
        },
        {
          key: 'ownership',
          content: 'Ownership',
        },
        {
          key: 'lastLogin',
          content: 'Last Login',
        },
      ]}
      rows={rows}
    />
  );
}
